export default __webpack_public_path__ + "static/media/soybean_milk.803e17a9.JPG";